module.exports = __webpack_public_path__ + "loader-logo.png";